import { render } from "./siteprivilege.vue?vue&type=template&id=3b5a0379&scoped=true"
import script from "./siteprivilege.vue?vue&type=script&lang=js"
export * from "./siteprivilege.vue?vue&type=script&lang=js"

import "./siteprivilege.vue?vue&type=style&index=0&id=3b5a0379&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5a0379"]])

export default __exports__